import {
  alpha,
  Box,
  ButtonBase,
  Grid,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

interface MonthCellProps {
  monthName?: string;
  rawMonth?: Dayjs;
  disabled?: boolean;
  selected?: boolean;
  inPreview?: boolean;
  isPreviewStart?: boolean;
  isPreviewEnd?: boolean;
  roundStart?: boolean;
  roundEnd?: boolean;
  inSelectedRange?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: (month: Dayjs) => void;
}

export const MonthCell = ({
  monthName,
  rawMonth,
  disabled = false,
  selected = false,
  inPreview,
  isPreviewStart,
  isPreviewEnd,
  roundStart = false,
  roundEnd = false,
  inSelectedRange,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: MonthCellProps) => {
  return (
    <Grid item xs={3}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          pointerEvents: disabled ? "none" : "auto",
          py: 0.5,
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        <ButtonBase
          disabled={disabled}
          sx={(theme) => {
            const base: SxProps<Theme> = {
              width: "100%",
              height: 40,
              color: disabled
                ? theme.palette.grey[400]
                : selected
                  ? theme.palette.primary.contrastText
                  : "inherit",
              backgroundColor: selected
                ? theme.palette.primary.main
                : "transparent",
              borderWidth: 2,
              borderStyle: "solid",
              borderColor: "transparent",
              ":hover":
                disabled || selected
                  ? {}
                  : {
                      borderColor: theme.palette.grey["300"],
                      borderStyle: "solid",
                    },
            };

            if (inPreview && !selected) {
              base.borderStyle = "dashed";
              base.borderColor = theme.palette.grey["300"];
              base.borderLeftColor = "transparent";
              base.borderRightColor = "transparent";
            }

            if (isPreviewStart && !selected) {
              base.borderColor = theme.palette.grey["300"];
            }

            if (isPreviewEnd && !selected) {
              base.borderColor = theme.palette.grey["300"];
            }

            if (roundStart && !selected && inPreview) {
              base.borderLeftColor = theme.palette.grey["300"];
            }

            if (roundEnd && !selected && inPreview) {
              base.borderRightColor = theme.palette.grey["300"];
            }

            if (inSelectedRange) {
              base.backgroundColor = alpha(theme.palette.primary.light, 0.2);
            }

            return base;
          }}
          onClick={() => onClick?.(rawMonth ?? dayjs())}>
          <Typography variant="caption">{monthName}</Typography>
        </ButtonBase>
      </Box>
    </Grid>
  );
};
